import { Link } from 'react-router-dom';

export default function ComplianceSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Left Content */}
          <div className="lg:col-span-3">
            <p className="text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
              About Us
            </p>
            <h2 className="text-4xl font-bold text-navy-900 mb-6 leading-tight">
              B2B Research Supplier for Laboratories & Institutions
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p>
                We operate as a B2B catalog and quote-based ordering system, providing high-purity research peptides and biotech compounds to qualified laboratories, research institutions, universities, and biotech companies worldwide.
              </p>
              <p>
                Every product undergoes rigorous third-party testing and HPLC verification to ensure research-grade purity. We maintain strict quality control protocols throughout our supply chain, from sourcing to delivery, with full COA documentation available.
              </p>
              <p>
                Our ordering process requires manual quote approval to ensure compliance and proper handling. With secure cold-chain logistics and comprehensive documentation, we ensure that your research materials arrive in optimal condition for laboratory applications.
              </p>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center mt-6 px-6 py-3 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Read Our Story
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>

          {/* Right Disclaimer Box */}
          <div className="lg:col-span-2">
            <div className="bg-red-50 border-2 border-red-300 rounded-xl p-8">
              <div className="flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4 mx-auto">
                <i className="ri-alert-line text-3xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-bold text-red-900 mb-4 text-center">
                Research Use Only
              </h3>
              <p className="text-sm text-red-900 font-bold mb-4 leading-relaxed text-center">
                For Research Use Only. Not for human consumption, medical use, or household application.
              </p>
              <ul className="space-y-2 text-sm text-gray-800">
                <li className="flex items-start">
                  <i className="ri-flask-line text-red-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Laboratory research applications only</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-close-circle-line text-red-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Not for human or animal consumption</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-building-line text-red-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Qualified researchers and institutions only</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-file-list-3-line text-red-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Quote-based ordering with manual approval</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-shield-check-line text-red-600 mr-2 mt-0.5 flex-shrink-0"></i>
                  <span>Proper storage and handling required</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}